import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AuthorizationService } from '../../services/authorization.service';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AboutComponent {
	title = 'About';

	constructor(private authorizationService: AuthorizationService) { }

}
